import React,{ useCallback, useEffect } from "react";
import { useState } from "react";
import { Link, useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom";
import { getList } from "../../slices/AttendancesSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import { GoogleMap } from "../shoppingPartners/google-map";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { downloadAttendance } from "../../services/reports"
import { startDownload } from "../../Utils/utils/CommanFnc";
import { Loading } from "../../components/Loading"
import ModelBox from "../../common/ModelBox";
import SelectBox from "../../components/admin/SelectBox";
import { useMemo } from "react";

export function List() {
  const [todayDate, setTodayDate] = useState(moment(new Date()).format('YYYY-MM-DD') ) 
  const [pageName, setPageName] = useState('');
  const [attendanceData, setAttendanceData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams()
  const [isMapOpen, setIsMapOpen] = useState(false)
  const [latLng, setLatLng] = useState('');
  const [pageTitle, setPageTitle] = useState('')
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [userAttendance, setUserAttendance] = useState([]);
  const [activeUserId, setActiveUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState('');
  const [imageData, setImageData] = useState({});
  const [dateToDisplay, setDateToDisplay] = useState({});
  const [downloadOpt, setDownloadOpt] = useState([]);
  const dispatch = useDispatch(); 
  const navigate = useNavigate();

  const loggeInUserId = useSelector( (state) => state?.auth?.user?._id );
  const data = useSelector((state) => state.attendance);
  const loading = useSelector( (state) => state.attendance.loading);

  const queryString = Object.fromEntries([...searchParams.entries()]);
  const [serachString, setSearchString] = useState({
    date: queryString.date? queryString.date : '',
    endDate: queryString.endDate? queryString.endDate : ''
  })
  const defaultParams = {
    pageLength:defaultConfig.defaultLimit,
    date: '',
    endDate: '',
    parentUserId: '',
    all: true,
    page: 1
  }
  const location = useLocation();

  useEffect( () => {
    setDownloadOpt(() => {
      let opt = Object.keys(dateToDisplay).length > 0? [{
                  value: "download-month",
                  label: `All Team ${dateToDisplay.startDate} To ${dateToDisplay.endDate}`
                }] : [] ;
      if ( selectedUserName ) {
        opt.push({
          value: 'download-user',
          label: selectedUserName
        });
      }
      return opt;

    })
  }, [selectedUserName, serachString.date, serachString.endDate])

  useEffect( () => {
    setPageName(location.pathname)
    setTodayDate(moment(new Date()).format('YYYY-MM-DD'))
  },[location])

  const getMaxDate = function() {
    const nextDate = moment(Date.parse(serachString.date)).add(1, 'M');
    return Date.parse(nextDate);
  }

  const openMap = useCallback((latLng) => {
    if(isMapOpen){
      setIsMapOpen(false)
    }else{
      setLatLng(latLng)
      setIsMapOpen(true)
    }
  },[isMapOpen])

  useEffect(()=>{
    let data = {
        ...defaultParams,
        ...queryString
    }
    switch(pageName) {
      case '/team-attendances':
        data.parentUserId = queryString.parentUserId? queryString.parentUserId : '';
        setPageTitle('My Team Attendances');
        break;
      case '/all-attendances':
        data.parentUserId = queryString.parentUserId? queryString.parentUserId : ''
        setPageTitle('All Attendances');
      break;
      case '/my-attendances':
        data.userId = loggeInUserId;
        setPageTitle('My Attendances')
      default:
    }
    setSearchString({
        ...defaultParams,
        ...queryString
    })
    dispatch(getList({data}));
     // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch, pageName]);

  useEffect( ()=>{
    const { list, dates } = data;
    const attendance = list?.find( (item) => item.userId === activeUserId );
    setDateToDisplay(() => {
        return {
          startDate: moment(dates?.at(-1)).format("MMMM, DD YYYY"),
          endDate: moment(dates?.at(0)).format("MMMM, DD YYYY")
        }
    })
    setAttendanceData(list);
    setUserAttendance(attendance?.userAttendance);
    setSelectedUserName(attendance?.name || '')
  },[data.list])

  const setValue = (value, name) => {
    const query = {...serachString, [name]: value};
    if(name !== "endDate") {
      query.endDate = null;
    }
    setSearchString({...query})
  }

  const searchInt = () => {
      if(moment(serachString.date).isValid() && moment(serachString.endDate).isValid()){
        setUserAttendance([]);
        let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
        setSearchParams(params)  
        params.date = moment(Date.parse(params.date)).format('YYYY-MM-DD')
        params.endDate = moment(Date.parse(params.endDate)).format('YYYY-MM-DD')
        dispatch(getList({data:{...params}}))
      }
      
  }

  const resetSearch = () =>{
    const date = '';
    const endDate = '';
    const queryPrm = {pageLength: defaultConfig.defaultLimit, page:1, date, endDate}
    setSearchParams(queryPrm)
    setSearchString({ date, endDate }) 
    dispatch(getList({data:{...queryPrm}}))
  }

  const downloadReport = async (downloadType) => {
      setDownloadLoading(true);
      const startDate = moment(Date.parse(serachString.date)).format('YYYY-MM-DD');
      const endDate   = moment(Date.parse(serachString.endDate)).format('YYYY-MM-DD');
      const params    = {...serachString};
      let fileName    = `attendance-report-${startDate}-${endDate}.xlsx`;
      switch (downloadType) {
        case 'download-month': 

        break;
        case 'download-user':
          fileName = `${selectedUserName}-${fileName}`;
          params.userId = activeUserId;
        break;
      }
      const excelData = await downloadAttendance(params);
      startDownload(excelData, fileName);
      setDownloadLoading(false);
      
      
      // setDownloadLoading(false)
  }

  const showAttendance = (currentItem) => {
    setSelectedUserName(currentItem?.name);
    setUserAttendance(currentItem?.userAttendance);
    setActiveUserId(currentItem?.userId);
  }

  const showPunchImage = useCallback(({imgName, type}) => {
    const imgPath = `${defaultConfig.localDocFilePath}/images/${imgName}`
    const content = <div className="col-sm-8 text-center"><img className="rounded" src={imgPath} /></div>
    setImageData({
      imgName,
      title: `${type} Image`,
      content,
      size: 'lg',
      show: imageData.show === true? false : true
    })
  }, [imageData.show])

  const staffTeamAttendances = () => {
    const queryString  = new URLSearchParams({...serachString, parentUserId: activeUserId, all: true }).toString()
    navigate(`/team-attendances?${queryString}`);
    window.location.reload(true);
  }

  return (
    <React.Fragment>
      { downloadLoading || loading? <Loading/>: ''}
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> { pageTitle} 
                </h4>
              </div>
              <div className="row p-5">
                  <div className="col-md-9">  
                    <form className="form-inline">
                        <div className="form-group">
                          <div className="mr-1">
                            <label style={{'justifyContent':'left'}} className="text-left">Start Date</label>
                            <DatePicker 
                              showMonthDropdown 
                              showYearDropdown 
                              className="form-control" 
                              selected={serachString.date?Date.parse(serachString.date):''} 
                              maxDate={Date.parse(todayDate)}
                              onChange={(date) => setValue(moment(Date.parse(date)).format('YYYY-MM-DD'), 'date')}
                            />  
                            </div>
                          <div className="mr-1">
                            <label style={{'justifyContent':'left'}}>End Date</label>
                            <DatePicker
                              selected={serachString.endDate?Date.parse(serachString.endDate):''}
                              className="form-control"
                              onChange={(date) => setValue(moment(Date.parse(date)).format('YYYY-MM-DD'), 'endDate')}
                              minDate={Date.parse(serachString.date)}
                              showMonthDropdown
                              showYearDropdown
                              maxDate={getMaxDate(todayDate)}
                            />
                          </div>
                        </div>
                        <div >
                          <label>&nbsp;</label>
                          <button onClick={searchInt} type="button" className="btn btn-primary btn-lg">
                            <i className="fa fa-search"></i>
                          </button>
                          &nbsp;
                          <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                            <i className="fas fa-undo"></i>
                          </button>
                        </div>
                      
                    </form>
                  </div>
                  {
                    attendanceData?.length > 0 ? 
                        <div className="col-md-3">
                          {/* <button onClick={downloadReport} className="btn btn-success"> 
                              <i className="fa fa-download"></i> Download Report 
                          </button> */}
                            <div className="form-group">
                                <label className="d-block">Download Report</label>
                                <SelectBox 
                                  options={downloadOpt}
                                  onChange={ (e) =>  downloadReport(e.value)}
                                />
                              
                            </div>
                          </div> : '' 
                  }
              </div>
              <div className="container-fluid">
                <div className="row">
                  {
                     attendanceData?.length > 0 ?
                     <>
                        <div className="col-sm-3">
                          <ul className="user-list">
                            {
                            
                              attendanceData?.map((item, index) => {
                                return <li className={activeUserId === item.userId? "active": ''} key={`user-list-${index}`}> 
                                          <span onClick={()=>showAttendance(item)}> {item.name}</span>
                                      </li>
                              })
                            }
                          </ul>
                        </div>
                        <div className="col-sm-9">
                          {selectedUserName? <div className="row">
                            <div className="col-sm-8">
                              <h2>{selectedUserName || ''} &nbsp;&nbsp; { <small>{dateToDisplay?.startDate} TO {dateToDisplay?.endDate}</small>  } </h2>
                            </div>
                            <div className="col-sm-4 text-right">
                              { selectedUserName && pageName !== "/my-attendances"? <button onClick={()=>staffTeamAttendances()} className="btn btn-success"> View Team Attendances </button> : ''}
                            </div>
                          </div> : '' }
                          <div className="table-responsive datatable-wrap">
                            <table className="table dataTable table-hover">
                              <thead>
                                <tr>
                                  <th width="10%">Date & Day</th>
                                  <th width="10%">In Time</th>
                                  <th width="10%">Out Time</th>
                                  <th width="10%">In District</th>
                                  <th width="10%">Out District</th>
                                  <th width="10%">Beat Name</th>
                                  <th width="10%">Co-working</th>
                                  <th width="10%">Attendances</th>
                                  <th width="10%">Image</th>
                                </tr>
                              </thead>

                              <tbody>
                                {
                                (userAttendance?.length > 0)? userAttendance.map((item, index) => {
                                    return <tr key={`attendance-list-${index}`}>
                                        <td>{moment(Date.parse(item.date)).isValid? moment(Date.parse(item.date)).format("MMMM, DD YYYY, dddd") : '-'}</td>
                                        <td>{item.punchInTime || '-'}</td>
                                        <td>{item.punchOutTime || '-'}</td>
                                        <td>{<Link onClick={(_e)=>openMap(item.punchInLatLong)} className="sidebar-link" data-toggle="tab">
                                              { item.InCityName || '-' }
                                            </Link>}</td>
                                        <td>{<Link onClick={(e)=>openMap(item.punchOutLatLong)} className="sidebar-link" data-toggle="tab"> 
                                                {item.outCityName || '-'}
                                              </Link>}</td>
                                        <td>{item.inBeatName || '-'}</td>
                                        <td>{item.punchOutCoWorking !== "undefined" ? item.punchOutCoWorking : '-'}</td>
                                        <td>
                                          {
                                              item?.attendanceType? defaultConfig.attendanceType[item?.attendanceType] : "Present"
                                          }
                                        </td>
                                        <td>
                                        
                                            <Link onClick={(e)=>showPunchImage({imgName: item.punchInImage, type: "Punch In"})} className="sidebar-link" data-toggle="tab">
                                              In  
                                            </Link>
                                            /
                                            <Link onClick={(e)=>showPunchImage({imgName: item.punchOutImage, type: "Punch Out"})} className="sidebar-link" data-toggle="tab">
                                              Out Image  
                                            </Link>
                                          
                                        </td>
                                      </tr>
                                  }): <tr><td colSpan="8" style={{"textAlign":"center"}}>Please Select a user from list</td></tr>
                                }
                              </tbody>
                            </table>   
                          </div>
                        </div>  
                      </> :
                        <div className="col-sm-12">
                          <div className="alert alert-warning text-center" role="alert"> No one come under this employee. </div>
                        </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      
        {isMapOpen?<GoogleMap setLocationData={()=>{}} data={ {latLng, readOnly:true} } openMap={openMap} />:''}


        {imageData.show?<ModelBox 
                            data={ {
                                size: "lg", 
                                show: imageData.show, 
                                title: imageData.title, 
                                content: imageData.content,
                                onClose: () => { 
                                    setImageData({ show: false })
                                }  
                            } } /> :''}
      </div>
    </React.Fragment>
  );
}
